import type { AuthErrorCode, IAuthApiError, IAuthApiErrorBody } from './types';

export const parseApiError = (error: unknown): IAuthApiError => {
  const axiosError = error as {
    response?: { status?: number; data?: IAuthApiErrorBody };
    message?: string;
  };

  const data = axiosError.response?.data;
  const statusCode = data?.statusCode ?? axiosError.response?.status;
  const code = data?.code as AuthErrorCode | string | undefined;
  const message =
    data?.message ?? axiosError.message ?? 'Erro desconhecido. Tente novamente mais tarde.';

  const apiError = new Error(message) as IAuthApiError;
  apiError.statusCode = statusCode;
  apiError.code = code;

  return apiError;
};

export const isApiErrorCode = (error: unknown, code: AuthErrorCode): error is IAuthApiError => {
  return parseApiError(error).code === code;
};
